import $ from 'jquery'
import 'gsap'

module.exports = {
	namespace: 'product_index',
	beforeEnter() {

	},
	afterEnter(){

	},
	beforeLeave(){

	},
	afterLeave() {

	}
}
